import { logError } from './logging';

export enum SessionStorageKeys {
  CompetitionSubmitted = 'competitionSubmitted',
  SearchMethod = 'searchMethod',
  CartTrackingData = 'cartTrackingData',
  HideLoginTooltip = 'hideLoginTooltip',

  // Algolia
  AlgoliaInsights = 'algolia-insights',
  PdpServiceSelection = 'pdp-service-selections',
  PdpSelectedServiceSuggestion = 'pdp-selected-service-suggestion',
  GeolocationPermissionRequested = 'geoLocationPermissionRequested',

  CachedCart = 'cachedCart',
}

//
// Functions for session storage actions
//

/**
 * Set to sessionStorage
 */
export const setSession = (key: SessionStorageKeys, data: any, isJson = false) => {
  if (!window.sessionStorage) {
    return;
  }

  try {
    sessionStorage.setItem(key, isJson ? JSON.stringify(data) : data);
  } catch (e) {
    logError(e, 'Saving to sessionStorage failed');
  }
};

/**
 * Get from sessionStorage
 */
export const getSession = (key: SessionStorageKeys, isJson = false) => {
  if (!window.sessionStorage) {
    return '';
  }

  let data: any;
  try {
    data = sessionStorage.getItem(key);
    if (isJson) {
      data = JSON.parse(data);
    }
  } catch (e) {
    logError(e, 'Getting from sessionstorage failed');
  }

  return data;
};

/**
 * Remove sessionStorage
 */
export const removeSession = (key: SessionStorageKeys) => {
  if (!window.sessionStorage) {
    return;
  }

  sessionStorage.removeItem(key);
};
